import React from 'react'

import NumberField from 'modules/core/components/NumberField'
import { useUnsafeEffect } from 'modules/core/hooks/useEffect'
import i18n from 'modules/core/lib/i18n'

import { Element } from 'modules/forms/lib/Element'
import { Answer } from 'modules/forms/lib/types'

interface NumberElementQuestionProps {
  element: Element
  onChange?: (answer: Answer) => void
  disabled?: boolean
}

/**
 * Editor component for TextElement
 */
export const NumberElementQuestion: React.FC<NumberElementQuestionProps> = ({
  element,
  onChange,
  disabled,
}) => {
  const currentValue = element.answer ? Number(element.answer?.answer) : null
  const [value, setValue] = React.useState<number | null>(currentValue)

  useUnsafeEffect(() => {
    setValue(currentValue)
  }, [element.id, currentValue])

  const handleOnChange = (value: number | null) => {
    setValue(value)
    onChange?.({ answer: String(value) })
  }

  const hasAttemptedSubmit = false // TODO

  const getError = () => {
    if (hasAttemptedSubmit) {
      if (element.mandatory && !value) {
        return i18n.t('forms.render.answer_required')
      }
    }
    return undefined
  }

  return (
    <NumberField
      hideLabel
      label={element.label}
      mandatory={element.mandatory}
      placeholder={i18n.t('forms.render.answer_placeholder')}
      value={value}
      onChange={handleOnChange}
      readonly={disabled}
      error={getError()}
    />
  )
}
